/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetNewslettersRequest} from '../models/GetNewslettersRequest';

export interface GetUsersNewsletters$Request {
    getNewslettersRequest: GetNewslettersRequest;
}

export interface GetUsersNewsletters$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersNewslettersRequest = createAction<PayloadData<void, GetUsersNewsletters$Request>>('GET_USERS_NEWSLETTERS__GET_USERS_NEWSLETTERS__REQUEST');
export const getUsersNewslettersSuccess = createAction<PayloadData<{ [key: string]: Array<string>; }, GetUsersNewsletters$Request>>('GET_USERS_NEWSLETTERS__GET_USERS_NEWSLETTERS__SUCCESS');
export const getUsersNewslettersFailure = createAction<PayloadData<Error, GetUsersNewsletters$Request, true>>('GET_USERS_NEWSLETTERS__GET_USERS_NEWSLETTERS__FAILURE');

export const getUsersNewslettersActions = [
    getUsersNewslettersRequest,
    getUsersNewslettersSuccess,
    getUsersNewslettersFailure
] as const;

/**
 * @param {GetNewslettersRequest} meta.getNewslettersRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersNewsletters = (meta: GetUsersNewsletters$Request, config?: GetUsersNewsletters$Config) => {
    return {
        CALL_API: {
            types: getUsersNewslettersActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/newsletters`,
            TRANSPORT_REQUEST_BODY: meta.getNewslettersRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

